import getFetchOptions from 'utils/getFetchOptions';
import {ENDPOINT_URL, TEST_VERSION} from 'constants/index';

export const loginNoAuth = (data) => {
	return fetch(
		`${ENDPOINT_URL}/verifyNoAuth`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({...data, testVersion: TEST_VERSION}),
		})
	).then((response) => {
		if (response.ok) {
			return response.json();
		}
		return Promise.reject();
	});
};

export default loginNoAuth;
